import { useTranslation } from 'react-i18next';

import PeopleBow from '@/assets/images/PeopleBow.svg?react';

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen relative bg-[url('@/assets/images/BgSuccessScenarioE.png')] bg-cover bg-center bg-no-repeat">
      <div className='relative p-4 top-1/2 -translate-y-1/2 flex flex-col items-center gap-[60px]'>
        <img src={PeopleBow} className='w-full max-w-[334px]' alt='people-bow' />
        <div className='text-center'>
          <p className='font-bold text-24 text-lnk'>{t('common:msg_maintenance')}</p>
          <p className='max-w-[460px] mt-[16px] font-semibold text-16 text-textGray leading-[1.6]'>{t('common:msg_maintenance_desc')}</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
